import { Outlet } from '@remix-run/react'
import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => {
	return [
		{ title: 'Double Materiality Assessment' },
		{
			name: 'description',
			content: 'Assess and manage your IROs according to CSRD guidelines',
		},
	]
}

export default function MaterialityLayout() {
	return (
		<div className="container mx-auto px-4 py-8">
			<h1 className="mb-8 text-3xl font-bold">Double Materiality Assessment</h1>
			<Outlet />
		</div>
	)
}
